export function parseAmountToNumber(value: string): number {
	const parsed = parseFloat(value);
	return isNaN(parsed) ? 0 : Math.round(parsed * 100) / 100;
}
